<template>
  <div id="app">
     <v-app id="inspire" :class="{ 'is-logged-in-page': $isLoginPage}" :style="{background: $vuetify.theme.themes['dark'].background}">
      <!-- <navbar-template></navbar-template>
      <headnav-template></headnav-template> -->
      <navbar-template v-if="$store.state.isLoggedIn && $store.state.isAuthFactorPass"></navbar-template>
      <headnav-template v-if="$store.state.isLoggedIn && $store.state.isAuthFactorPass"></headnav-template>

      <v-main>
          <v-container v-if="$isLoginPage" fluid :class="($currentLoginRoleBgClass ? $currentLoginRoleBgClass : '')" class="container-login">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
          </v-container>
          <v-container v-else class="px-6" fluid :fill-height="centerContainer()">
              <v-row>
                  <v-col cols="12">
                      <transition name="fade" mode="out-in">
                          <router-view></router-view>
                      </transition>
                  </v-col>
              </v-row>
          </v-container>
          
          <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
      </v-main>
    </v-app>
  </div>
</template>

<script>
  export default { 
    name: 'App',
    data(){
        return{
            overlay: false,
        };
    },
    methods:{
        centerContainer(){
            let arr = [
                'login',
                'two_factor_auth',
            ];

            if(arr.includes(this.$route.name)){
                return true;
            }
        },
    },
    created(){
        // this.$Fire.$on("overlay", (bol) => {
        //     this.overlay = bol;
        // });
    },
    mounted() {
        // console.log(this.$route.name);
    }
  }
</script>
<style lang="scss">@import "./assets/css/app";</style>
<style scoped>
    .fade-enter-from, .fade-leave-to{
        opacity: 0;
    }
    .fade-enter-active,
    .fade-leave-active{
        transition: opacity 0.15s ease-out;
    }
</style>